import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import RAGDemo from "./components/RAGDemo";
import ConciliacionDemo from "./components/ConciliacionDemo";
import AnalyticsDemo from "./components/AnalyticsDemo";
import CustomerServiceDemo from "./components/CustomerServiceDemo";
import DocumentAutomationDemo from "./components/DocumentAutomationDemo";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const authCookie = Cookies.get('iqsit-demo-auth');
    if (authCookie === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    Cookies.set('iqsit-demo-auth', 'true', { expires: 7 }); // 7 days
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    Cookies.remove('iqsit-demo-auth');
  };

  // Simple loading screen
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <Login onLogin={handleLogin} />
              )
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? (
                <Dashboard onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/demo/rag" 
            element={
              isAuthenticated ? (
                <RAGDemo onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/demo/conciliacion" 
            element={
              isAuthenticated ? (
                <ConciliacionDemo onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/demo/analytics" 
            element={
              isAuthenticated ? (
                <AnalyticsDemo onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/demo/customer-service" 
            element={
              isAuthenticated ? (
                <CustomerServiceDemo onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/demo/document-automation" 
            element={
              isAuthenticated ? (
                <DocumentAutomationDemo onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="*" 
            element={<Navigate to="/" replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 